import { render, staticRenderFns } from "./BudgetSettingsSection.vue?vue&type=template&id=53e79d60&scoped=true&"
import script from "./BudgetSettingsSection.vue?vue&type=script&setup=true&lang=js&"
export * from "./BudgetSettingsSection.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./BudgetSettingsSection.vue?vue&type=style&index=0&id=53e79d60&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e79d60",
  null
  
)

export default component.exports